/* 🤖 this file was generated by svg-to-ts */
export const matIconTextRotateVertical: {
  name: 'text-rotate-vertical';
  data: string;
} = {
  name: 'text-rotate-vertical',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 20l3-3H7V4H5v13H3l3 3z"/></svg>`
};
